import { render, staticRenderFns } from "./price-aggreement-add-or-update.vue?vue&type=template&id=7b2921e4&scoped=true"
import script from "./price-aggreement-add-or-update.vue?vue&type=script&lang=js"
export * from "./price-aggreement-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./price-aggreement-add-or-update.vue?vue&type=style&index=0&id=7b2921e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2921e4",
  null
  
)

export default component.exports